module.exports = __webpack_public_path__ + "media/images/spinner-65e7b42ce0de1e7f95e4808157aaacfd.svg";